import * as React from 'react';
import { UitkPlaceholderCard, UitkPlaceholderCardPhase } from 'uitk-react-cards';

export interface PlaceholderCardProps {
  index: number;
  className?: string;
}

export const PlaceholderCard: React.FunctionComponent<PlaceholderCardProps> = ({ index, className }) => (
  <UitkPlaceholderCard
    className={`listing__card ${className}`}
    startPhase={index % 2 === 0 ? UitkPlaceholderCardPhase.DARK : UitkPlaceholderCardPhase.LIGHT}
  />
);
